import type { HeadlineSize } from '@xing-com/typography';

type HeadlineFontSizeProps = {
  size: HeadlineSize;
  sizeConfined: HeadlineSize;
  sizeWide: HeadlineSize;
};

export const variantToHeadlineFontSize: Record<
  'default' | 'hero',
  Record<'size' | 'sizeConfined' | 'sizeWide', HeadlineFontSizeProps['size']>
> = {
  default: {
    size: 'large',
    sizeConfined: 'large',
    sizeWide: 'xlarge',
  },
  hero: {
    size: 'xlarge',
    sizeConfined: 'xxlarge',
    sizeWide: 'xxxlarge',
  },
};
